class CompreJunto {
  constructor() {
    this.container = document.querySelector('[data-compre-junto]');
    if (!this.container) return;
    
    this.checkboxes = [];
    this.swatchOptions = [];
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.updateTotal();
  }
  
  bindEvents() {
    // Checkboxes dos produtos
    this.checkboxes = this.container.querySelectorAll('.compre-junto-checkbox');
    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => this.updateTotal());
    });
    
    // Swatch options
    this.swatchOptions = this.container.querySelectorAll('.compre-junto-swatch-options .swatch-option');
    this.swatchOptions.forEach(swatch => {
      swatch.addEventListener('click', (e) => this.handleSwatchSelection(e));
    });
    
    // Botão de finalizar compra
    const checkoutButton = this.container.querySelector('[data-compre-junto-checkout]');
    if (checkoutButton) {
      checkoutButton.addEventListener('click', (e) => this.handleCheckout(e));
    }
  }
  
  handleSwatchSelection(event) {
    event.preventDefault();
    
    const swatch = event.currentTarget;
    const productHandle = swatch.dataset.productHandle;
    const variantId = swatch.dataset.variantId;
    const variantPrice = swatch.dataset.variantPrice;
    
    if (!productHandle || !variantId || swatch.disabled) return;
    
    // Remove seleção anterior do mesmo produto
    const productContainer = this.container.querySelector(`[data-product-handle="${productHandle}"]`);
    if (productContainer) {
      const previousSwatches = productContainer.querySelectorAll('.swatch-option--selected');
      previousSwatches.forEach(prevSwatch => {
        prevSwatch.classList.remove('swatch-option--selected');
      });
      
      // Adiciona seleção atual
      swatch.classList.add('swatch-option--selected');
      
      // Atualiza checkbox com nova variant
      const checkbox = productContainer.querySelector('.compre-junto-checkbox');
      if (checkbox) {
        checkbox.dataset.productId = variantId;
        checkbox.dataset.productPrice = variantPrice;
      }
      
      // Atualiza imagem do produto se disponível
      const productImage = productContainer.querySelector('[data-product-image]');
      if (productImage) {
        const variantImageSrc = swatch.dataset.variantImage;
        if (variantImageSrc) {
          productImage.src = variantImageSrc;
        }
      }
      
      // Atualiza preço do produto
      const priceElement = productContainer.querySelector('[data-product-price]');
      if (priceElement) {
        const price = parseFloat(variantPrice) / 100;
        const formattedPrice = this.formatPrice(price);
        priceElement.textContent = formattedPrice;
      }
      
      // Recalcula total
      this.updateTotal();
    }
  }
  
  getSelectedProducts() {
    const selectedProducts = [];
    
    // Apenas produtos upsell selecionados
    this.checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        selectedProducts.push({
          id: checkbox.dataset.productId,
          quantity: 1
        });
      }
    });
    
    return selectedProducts;
  }
  
  updateTotal() {
    const totalElement = this.container.querySelector('[data-kit-total]');
    const checkoutButton = this.container.querySelector('[data-compre-junto-checkout]');
    
    let total = 0;
    let selectedCount = 0;
    
    // Calcula total baseado apenas nos produtos upsell selecionados
    this.checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const productPrice = parseFloat(checkbox.dataset.productPrice) / 100;
        total += productPrice;
        selectedCount++;
      }
    });
    
    if (totalElement) {
      const formattedPrice = this.formatPrice(total);
      totalElement.textContent = formattedPrice;
    }
    
    if (checkoutButton) {
      checkoutButton.disabled = selectedCount === 0;
    }
  }
  

  
  formatPrice(price) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(price);
  }
  
  async handleCheckout(event) {
    event.preventDefault();
    
    const selectedProducts = this.getSelectedProducts();
    const checkoutButton = this.container.querySelector('[data-compre-junto-checkout]');
    
    if (selectedProducts.length === 0) {
      alert('Nenhum produto selecionado');
      return;
    }
    
    try {
      if (checkoutButton) {
        checkoutButton.classList.add('loading');
        checkoutButton.disabled = true;
      }
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: selectedProducts
        })
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Erro na resposta:', response.status, errorText);
        throw new Error('Erro ao adicionar produtos ao carrinho');
      }
      
      const result = await response.json();
      
      // Get the first added item for the notification
      const addedItem = result.items ? result.items[0] : result;

      // Dispatch notification event
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: {
          items: result.items ? result.items : [result]
        }
      }));

      // Update cart drawer in background
      document.dispatchEvent(new CustomEvent('updateCartDrawer'));
      
      const errorElement = this.container.querySelector('[data-compre-junto-error]');
      if (errorElement) errorElement.textContent = '';
      
    } catch (error) {
      console.error('Erro ao adicionar produtos ao carrinho:', error);
      const errorElement = this.container.querySelector('[data-compre-junto-error]');
      if (errorElement) {
        errorElement.textContent = 'Erro ao adicionar produtos ao carrinho. Tente novamente.';
      }
    } finally {
      if (checkoutButton) {
        checkoutButton.classList.remove('loading');
        checkoutButton.disabled = false;
      }
    }
  }
  

}

// Inicializa quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function() {
  new CompreJunto();
});
